import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "rgbcolor"
    }}>{`RGBColor`}</h1>
    <p>{`Defines an RGB color, used in `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/solidcolor/"
      }}>{`SolidColor`}</a>{` object.`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`blue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The blue color value.  `}<strong parentName="td">{`\``}{`default`}{`\``}</strong>{` 255  `}<strong parentName="td">{`\``}{`range`}{`\``}</strong>{` 0..255`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`green`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The green color value.  `}<strong parentName="td">{`\``}{`default`}{`\``}</strong>{` 255  `}<strong parentName="td">{`\``}{`range`}{`\``}</strong>{` 0..255`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`hexValue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The hexadecimal representation of the color in uppercase.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`red`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The red color value.  `}<strong parentName="td">{`\``}{`default`}{`\``}</strong>{` 255  `}<strong parentName="td">{`\``}{`range`}{`\``}</strong>{` 0..255`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      